define([
    'jQuery',
    'underscore',
    'library/fcse-widget/widget',
    'library/fcse-util/url'
], function($, _, Widget, Url) {

    var TagBarSearch = function(element, options, scope) {

        var defaultOptions = {
            tagBarWidget: null,
            rootScope: null
        };

        options = $.extend({}, defaultOptions, options || {});

        if (!options.tagBarWidget) {
            throw new Error('Widget "tagBarWidget" is not defined');
        }
        if (!options.rootScope) {
            throw new Error('Scope "rootScope" is not defined');
        }

        Widget.apply(this, [element, options]);

        this._init();
    };

    TagBarSearch.prototype = $.extend(Object.create(Widget.prototype), {
        _init: function() {
            var self = this;
            var tagBarWidget = this.option('tagBarWidget');

            tagBarWidget.on('change', function() {
                var value = self._getValueFromTagBar();
                if (!_.isEqual(value, self.value)) {
                    self.setValue(value);

                    if (!value.hotelName) {
                        self.element.addClass('is-hidden');
                    }
                }
            });

            this.setValue(this._getValueFromTagBar());
        },

        setValueToUi: function() {
            var tagBarWidget = this.option('tagBarWidget');
            tagBarWidget.setValue(this.value ? [this.value.hotelName] : []);
        },

        getValueFromUi: function() {
            return this._getValueFromTagBar();
        },

        _getValueFromTagBar: function() {
            var tagBarWidget = this.option('tagBarWidget');
            var barValue = tagBarWidget.getValue();
            return {
                hotelName: barValue && barValue.length ? barValue[0] : ''
            };
        },

        getValue: function() {
            var urlObj = new Url();
            var result = {};
            var tagBarValue = this._getValueFromTagBar();
            var hotelName = tagBarValue.hotelName;

            if (hotelName && this.element.data('use-product-code')) {
                result.productCode = hotelName;
                result.hotelName = '';
            } else if (hotelName && urlObj.query.productCode) {
                result.productCode = urlObj.query.productCode;
                result.hotelName = '';
            } else {
                result.hotelName = hotelName;
                result.productCode = '';
            }

            return result;
        }
    });

    return TagBarSearch;
});


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/tagbarsearch/tagBarSearch.js